import { useLocation } from "react-router-dom";
import { useLocalFeatureEnabled } from "src/hooks/use-local-feature";
import { useClusterManagerVisible } from "src/hooks/use-cluster-manager-visible";
import { getTabs } from "./header-tabs";
import { useRouter } from "src/routes/hooks";
import { ButtonBase, styled } from "@mui/material";
import { DropdownTabNav } from "./dropdownTabNav";

const TabButton = styled(ButtonBase)(({ theme }) => ({
  padding: theme.spacing(0.5, 1.5),
  borderRadius: 6,
  fontSize: 15,
  fontWeight: 400,
  color: theme.palette.text.secondary,
  "&.active": {
    fontWeight: 600,
    color: "#333C47",
    backgroundColor: "#f1f7b5",
  },
  "&:not(.active):hover": {
    color: theme.palette.mode === "dark" ? theme.palette.common.white : "black",
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(0, 0, 0, 0.05)"
        : "rgba(145, 158, 171, 0.1)",
  },
  // Signal 2026 Figma spec, opt-in through `redesigned` (see ROUTES_WITH_REDESIGNED_HEADER).
  "&.redesigned": {
    height: 34,
    padding: theme.spacing(0.75, 1),
    borderRadius: 8,
    fontSize: 14,
    lineHeight: "22px",
    color: "#919EAB",
  },
  // `&.redesigned` comes later at the same specificity as `&.active`: restore the active colour.
  "&.redesigned.active": {
    color: "#333C47",
  },
}));

export const HeaderTabs = ({
  currentPath,
  role,
  redesigned = false,
}: {
  currentPath: string;
  role?: string;
  redesigned?: boolean;
}) => {
  const router = useRouter();
  const location = useLocation();

  const localEnabled = useLocalFeatureEnabled();
  const clusterManagerVisible = useClusterManagerVisible();

  const tabsObj = getTabs(role, { localEnabled, clusterManagerVisible });
  const currentTabs = tabsObj[currentPath] || [];

  return (
    <div style={{ display: "flex", gap: "6px" }}>
      {currentTabs
        .filter((tab: any) => !tab.type || tab.type !== "root")
        .map((tab: any) => {
          if (tab.dropdown && tab.options?.length) {
            return (
              <DropdownTabNav
                key={tab.path}
                label={tab.label}
                options={tab.options}
                router={router}
                location={location}
              />
            );
          }

          const isActive =
            location.pathname === (typeof tab.path === "function" ? tab.path({}) : tab.path);

          return (
            tab.label &&
            <TabButton
              key={tab.path}
              className={[isActive && "active", redesigned && "redesigned"].filter(Boolean).join(" ")}
              onClick={() =>
                router.push(typeof tab.path === "function" ? tab.path({}) : tab.path)
              }
            >
              {tab.label || tab.title}
            </TabButton>
          );
        })}
    </div>
  );
};